/**
 * Bridge between the backend's human-readable category names and the
 * frontend's i18n bundle. The category list itself (id, order, section,
 * count) is fetched from `GET /parameters/categories` — this map exists
 * purely so existing translations under `configuration.categories.*`
 * still resolve. A category whose name has no entry here renders with the
 * raw backend `name` as the label.
 */
export const CATEGORY_NAME_TO_I18N_KEY: Readonly<Record<string, string>> = {
  'Parity & Validation': 'categories.parity_validation',
  'SKU Eligibility': 'categories.sku_eligibility',
  'Duration & Setup': 'categories.duration_setup',
  'Out of Stock': 'categories.out_of_stock',
  'Alerts & Thresholds': 'categories.alerts_thresholds',
  'Traffic Optimization': 'categories.traffic_optimization',
  'System & Engineering': 'categories.system_engineering',
  'Phased Rollout': 'categories.phased_rollout',
  'Recurring Feed Push Cadence': 'categories.recurring_feed_push_cadence',
};
